import { Effect, Layer, Schema } from "effect";
import { markdownCopyFailure, type MarkdownCopySelection } from "./markdown-copy-model.ts";
import { MarkdownCopyIo } from "./markdown-copy-service.ts";

const current = (selection: MarkdownCopySelection) => selection.root.isConnected && selection.root.contains(selection.button) && selection.root.contains(selection.code)
  && selection.button.closest('[data-component="markdown-code"]')?.querySelector("code") === selection.code
  && selection.code.textContent === selection.text;
export const MarkdownCopyIoLive = Layer.succeed(MarkdownCopyIo, {
  select: (root, target) => Effect.try({ try: () => {
    const view = root.ownerDocument.defaultView;
    if (!view || !(target instanceof view.Element) || !root.isConnected || !root.contains(target)) return;
    const button = target.closest('[data-slot="markdown-copy-button"]');
    if (!button || !root.contains(button)) return;
    const code = button.closest('[data-component="markdown-code"]')?.querySelector("code"), text = code?.textContent;
    return code && root.contains(code) && text ? { root, button, code, text } : undefined;
  }, catch: markdownCopyFailure }),
  writeText: text => Effect.try({ try: () => navigator.clipboard, catch: markdownCopyFailure }).pipe(Effect.flatMap(clipboard => clipboard
    ? Effect.tryPromise({ try: () => clipboard.writeText(text), catch: markdownCopyFailure }).pipe(
      Effect.flatMap(value => Schema.decodeUnknownEffect(Schema.Undefined)(value).pipe(Effect.mapError(markdownCopyFailure))), Effect.as(true))
    : Effect.succeed(false))),
  feedback: (selection, copied) => Effect.try({ try: () => {
    if (!current(selection)) return false;
    selection.button.setAttribute("data-copied", String(copied));
    return true;
  }, catch: markdownCopyFailure })
});
